import { Attributes, Misc, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class InvestmentInterest extends TemporalEntity {
    static typeName = "InvestmentInterest";

    constructor() {
        super();
        this.makeObservable();
    }

    public investmentInterestId: number = 0;

    public issuerInvestmentId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public interestDate: Date | null = null;

    @Rules.Required()
    @Attributes.Float()
    public interest: number = 0;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New investment interest";
        } else {
            return "Investment Interest";
        }
    }
}